import "text-encoding-polyfill";
import Joi from "joi";

const confirmEmailSchema = Joi.object({
	otp: Joi.string().min(6).max(6).required(),
});

export default confirmEmailSchema;
